module.exports = __webpack_public_path__ + "img/QRcord_ins.ad9e2914.png";